'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactGoogleCharts = require('react-google-charts');
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _getDefaultChartData = require('../../helpers/getDefaultChartData');var _getDefaultChartData2 = _interopRequireDefault(_getDefaultChartData);
var _Modal = require('../../components/Modal/Modal');var _Modal2 = _interopRequireDefault(_Modal);
var _constants = require('../../constants');
var _ChartOfViews = require('./ChartOfViews.scss');var _ChartOfViews2 = _interopRequireDefault(_ChartOfViews);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
var
ChartOfViews = function (_Component) {_inherits(ChartOfViews, _Component);function ChartOfViews() {var _temp, _this, _ret;_classCallCheck(this, ChartOfViews);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    calcTicks = function (maxValue) {
      var ticks = [];
      var range = maxValue < 10 ? 10 : maxValue;
      var step = void 0;

      if (maxValue <= 10) {
        step = 2;
      } else if (maxValue <= 50) {
        step = 5;
      } else {
        step = 10;
      }

      for (var i = step; i <= range; i += step) {
        ticks.push(i);
      }

      return ticks;
    }, _this.

    renderChart = function (chartData) {
      var values = !!chartData.length && chartData[0].events.map(function (_ref) {var count = _ref.count;return count;});
      var maxValue = values ? Math.max.apply(null, values) : 10;
      var ticks = _this.calcTicks(maxValue);var
      isRtl = _this.props.isRtl;

      var options = {
        legend: 'none',
        curveType: 'function',
        pointSize: 6,
        vAxis: {
          minValue: 0,
          ticks: ticks },

        hAxis: {
          direction: isRtl ? -1 : 1 },

        tooltip: {
          isHtml: true,
          trigger: 'selection' },

        series: {
          0: { targetAxisIndex: Number(isRtl) } } };



      var views = _this.props.translate('views').toString();
      var data = !!chartData.length && chartData[0].events.map(function (_ref2) {var count = _ref2.count,date = _ref2.date;return [(0, _moment2.default)(date).format('DD.MM'), count];});

      if (!data) {return true;}

      data.unshift(['Date', views]);

      return (
        _react2.default.createElement('div', { className: _ChartOfViews2.default.chartWrapper },
          _react2.default.createElement(_reactGoogleCharts.Chart, {
            chartType: 'AreaChart',
            data: data,
            options: options,
            width: '750px',
            height: '300px',
            curveType: 'none',
            axisTitlesPosition: 'none' })));



    }, _this.

    renderDescription = function () {var _this$props =








      _this.props,translate = _this$props.translate,_this$props$propertie = _this$props.propertiesAnalytics,publishDate = _this$props$propertie.publishDate,_this$props$propertie2 = _this$props$propertie.propertyViews,propertyViews = _this$props$propertie2 === undefined ? 0 : _this$props$propertie2,_this$props$propertie3 = _this$props$propertie.chartData,chartData = _this$props$propertie3 === undefined ? [] : _this$props$propertie3,_this$props$propertie4 = _this$props$propertie.analyticsAction,analyticsAction = _this$props$propertie4 === undefined ? '' : _this$props$propertie4;

      var title = translate('property_' + analyticsAction + '_stats').replace('quantity', _constants.viewsPeriodOnChart);

      var periodAmount = chartData.length ?
      chartData[0].events.
      reduce(function (_ref3, _ref4) {var prevCount = _ref3.count;var currCount = _ref4.count;return { count: prevCount + currCount };}).count :
      0;

      var amountOfLastPeriod = translate('amountLast_' + analyticsAction + '_period').
      replace('quantity', _constants.viewsPeriodOnChart).
      replace('periodAmount', periodAmount);

      return (
        _react2.default.createElement('div', { className: _ChartOfViews2.default.chartDescription },
          _react2.default.createElement('div', { className: _ChartOfViews2.default.title }, title),
          _react2.default.createElement('div', { className: _ChartOfViews2.default.description },
            _react2.default.createElement('div', null, propertyViews, ' ', translate('amountProperty_' + analyticsAction), ' (', publishDate, ')'),
            _react2.default.createElement('div', null, amountOfLastPeriod))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}ChartOfViews.prototype.

  render = function render() {var _props$propertiesAnal =
    this.props.propertiesAnalytics,isViewsChartOpen = _props$propertiesAnal.isViewsChartOpen,chartData = _props$propertiesAnal.chartData;
    var chart = chartData && chartData.length ? chartData : (0, _getDefaultChartData2.default)();

    return (
      _react2.default.createElement(_Modal2.default, {
          isOpen: isViewsChartOpen,
          onRequestClose: this.props.onRequestClose,
          className: 'viewsChartModal',
          contentLabel: 'Chart Views Modal',
          isRtl: this.props.isRtl },

        isViewsChartOpen && this.renderDescription(),
        isViewsChartOpen && chartData && this.renderChart(chart)));


  };return ChartOfViews;}(_react.Component);exports.default = ChartOfViews;


ChartOfViews.propTypes = {
  onRequestClose: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  propertiesAnalytics: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ChartOfViews/ChartOfViews.js
// module id = 2959
// module chunks = 0